export const getStatusMap = (row, all) => {
  const { client } = row
  const map = new Map([
    [0, '草稿'],
    [1, '待审核'],
    [2, '审核未通过'],
    [4, '已启用'],
    [5, '已下架']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(client) && map.get(client)) || ''
}

export const getBannerPosition = (row, all) => {
  const { slotKey } = row
  const map = new Map([
    ['banner1', 'banner1'],
    ['banner2', 'banner2'],
    ['banner3', 'banner3'],
    ['banner4', 'banner4'],
    ['left', '左侧'],
    ['right_top', '右上'],
    ['right_bottom', '右下'],
    ['left_top', '左上'],
    ['left_bottom', '左下'],
    ['right', '右侧']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(slotKey) && map.get(slotKey)) || ''
}

export const getAdGroupStatusMap = (row, all) => {
  const { state } = row
  const map = new Map([
    [0, '草稿'],
    [1, '待审核'],
    [2, '审核未通过'],
    [3, '已启用'],
    [4, '已隐藏']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(state) && map.get(state)) || ''
}

export const getTopBannerStatusMap = (row, all) => {
  const { status } = row
  const map = new Map([
    [1, '待审核'],
    [2, '审核未通过'],
    [3, '未开始'],
    [4, '进行中'],
    [5, '已下架']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(status) && map.get(status)) || ''
}
